import type { ReactNode } from 'react';
import {
  DialogContent,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Dialog,
} from '@src/design-system/dialog';
import { Text } from '@src/design-system/text';
import { Trash } from 'iconsax-react';
import { Button } from '@src/design-system/button';

type Props = {
  open: boolean;
  onOpenChange: (value: boolean) => void;
  cancelHandler: () => void;
  confirmationHandler: () => void;
  /** Defaults to the delete copy used across the app. */
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  isLoading?: boolean;
  /** Defaults to the trash icon used for delete confirms. */
  icon?: ReactNode;
};

const ConfirmationDeleteDialog = ({
  open,
  onOpenChange,
  cancelHandler,
  confirmationHandler,
  message = 'Are you sure you want to delete this item?',
  confirmLabel = 'Yes, Delete',
  cancelLabel = 'No, cancel',
  isLoading = false,
  icon,
}: Props) => {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent
        align='center'
        className='rounded-xl'
      >
        <DialogHeader
          onClose={cancelHandler}
          className='bg-white'
        ></DialogHeader>
        <DialogBody className='flex flex-col items-center justify-center gap-4 py-0'>
          <div className='rounded-2xl bg-red-100 p-3'>
            {icon ?? (
              <Trash
                size='24'
                color='#F05252'
              />
            )}
          </div>
          <Text
            variant='p'
            className='text-center font-normal text-base text-gray-700'
          >
            {message}
          </Text>
        </DialogBody>
        <DialogFooter className='justify-center!'>
          <Button
            variant='ghost'
            className='border-primary-200 border rounded-lg text-gray-800'
            disabled={isLoading}
            onClick={cancelHandler}
          >
            {cancelLabel}
          </Button>
          <Button
            variant='danger'
            onClick={confirmationHandler}
            className='bg-red-700'
            isLoading={isLoading}
            disabled={isLoading}
          >
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationDeleteDialog;
